import { isValidEmailAddress, isValidPassword } from '../functions';


$(document).ready(function() {

    // $(document).on('click', '#submit-login-form-btn', function() {
	// 	$('#login-form').submit();
    // });

});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/login.js